<template>
  <div class="row __container optionManager">
    <div class="col-md-12 optionManagerToolbar" v-if="onEditionId == null">
      <div class="optionManagerMeta">
        {{ dataArray.length }} element(s)
      </div>
      <b-button
        v-if="!__preview"
        size="sm"
        variant="primary"
        class="optionManagerAddBtn"
        @click="addAction()"
      >
        Ajouter
      </b-button>
    </div>
    <div class="col-md-12" v-if="onEditionId !== null">
      <Edit
        :__item="onEditionItem"
        :__isOnLoad="isEditOnload"
      ></Edit>
    </div>
    <div :class="listStyle">
      <List
        :__list="dataArray"
        :__isOnLoad="isListOnload"
        :__editMode="this.onEditionId != null"
        :__idxOnEdition="this.onEditionIdx"
        :__type="this.TYPE"
        :__preview="__preview"
        :__customCB="__customCB"
        :__current="__current"
      ></List>
    </div>
    
    <div v-if="this.onShowSubId !== null" class="col-md-6">
      <recOpts :CID="this.onShowSubId"></recOpts>
    </div>

  </div>
</template>
<script>
import Edit from './Edit';
import List from './List';
import recOpts from '@/pages/opts_sub/index';
export default {
  components: {
    Edit,
    List,
    recOpts,
  },
  props: {
    __current: {
      type: String,
      default: () => {
        return '';
      },
    },
    __preview: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    __customCB: {
      type: Function,
      default: () => {
        return ()=>{};
      },
    },
    PID: {
      type: String,
      default: () => {
        return '';
      },
    },
    CID: {
      type: String,
      default: () => {
        return undefined;
      },
    },
    TYPE: {
      type: String,
      default: () => {
        return 'DD';
      },
    },
  },

  data() {
    return {
      moduleRoute: '/opts',
      onEditionId: null,
      onEditionIdx: -1,
      onEditionItem: null,
      isListOnload: false,
      isEditOnload: false,
      dataArray: [],
      onGoingReq:[],
      onShowSubId: null,
    };
  },

  computed: {
    listStyle() {
      return this.onShowSubId !== null ? 'col-md-6' : 'col-md-12';
    },
  },

  methods: {
    createEmptyItem() {
      return {
        name: '',
        isActive: true,
        pID: this.PID,
        childOf: '0',
      };
    },

    showSub(id) {
      this.onShowSubId = id;
    },

    cancelAction() {
      this.onEditionId = null;
      this.onEditionIdx = -1;
      this.onEditionItem = null;
    },

    saveAction() {
      if (this.onEditionId === '__draft__') {
        this.createAction();
        return;
      }

      this.onGoingReq.push({});
      let $onNext = (response) => {
        this.loadData(this.onEditionId, null, this.onEditionIdx);
        if(this.$props.__customCB) {
          this.$props.__customCB(this.onEditionItem.name)
        }
      };

      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };
      this.dataArray[this.onEditionIdx].params = {};
      console.log(this.dataArray[this.onEditionIdx], this.onEditionItem)
      let diff = this.__.differ(
        this.dataArray[this.onEditionIdx],
        this.onEditionItem
      );
      diff.push('_id');
      let data = this._.pick(this.onEditionItem, diff);
      this.updateAction({ $onNext, $onError, $onComplete, data });
    },

    toggleActivateAction(id, val) {
      const findIdx = (element) => element._id == id;
      var idx = this.dataArray.findIndex(findIdx);
      this.onGoingReq.push({});
      let $onNext = (response) => {
        this.dataArray[idx].isActive = val;
      };

      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      let data = this._.pick(this.dataArray[idx], ['_id', 'isActive']);
      data.isActive = val;
      this.updateAction({ $onNext, $onError, $onComplete, data });
    },

    deleteAction(id) {
      const findIdx = (element) => element._id == id;
      var idx = this.dataArray.findIndex(findIdx);
      this.onGoingReq.push({});
      let $onNext = (response) => {
        if (response.data == 'OK') {
          this.dataArray.splice(idx, 1);
        }
      };

      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      let data = this._.pick(this.dataArray[idx], ['_id']);
      this.__.httpAction({
        methode: 'DELETE',
        route: this.moduleRoute+"/"+data._id,
        data: {},
        onNext: $onNext,
        onError: $onError,
        onComplete: $onComplete,
      });
    },

    editAction(id) {
      const findIdx = (element) => element._id == id;
      var idx = this.dataArray.findIndex(findIdx)
      this.onEditionId = id;
      this.onEditionIdx = idx;
      this.onEditionItem = this._.omit(this.dataArray[idx]);
    },

    updateAction(conf) {
      this.__.httpAction({
        methode: 'POST',
        route: this.moduleRoute,
        data: conf.data,
        onNext: conf.$onNext,
        onError: conf.$onError,
        onComplete: conf.$onComplete,
      });
    },

    createAction() {
      this.onGoingReq.push({});
      const $onNext = (response) => {
        this.loadData(response.data, () => {
          this.editAction(response.data);
          if(this.$props.__customCB) {
            this.$props.__customCB(this.onEditionItem.name)
          }
        });
      };

      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      const data = this._.omit({ ...this.onEditionItem, parentID: this.PID }, ['_id']);
      this.__.httpAction({
        methode: 'PUT',
        route: this.moduleRoute,
        data,
        onNext: $onNext,
        onError: $onError,
        onComplete: $onComplete,
      });
    },

    addAction(PID) {
      if(this.PID == undefined )
        return;
      this.onEditionId = '__draft__';
      this.onEditionIdx = -1;
      this.onEditionItem = this.createEmptyItem();
    },

    loadData(id = null, cb = null, putAt = null) {
      let $onNext = (response) => {
        if (id != null) {
          if (putAt != null) {
            this.dataArray[putAt] = response.data[0];
          } else {
            this.dataArray.push(response.data[0]);
          }

          if (cb) cb();
        } else {
          this.dataArray = response.data;
        }
      };

      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      this.onGoingReq.push({});
      this.__.httpAction({
        methode: 'GET',
        route: this.moduleRoute+ (id != null ? '/'+id : '/list/'+this.PID),
        data: {},
        onNext: $onNext,
        onError: $onError,
        onComplete: $onComplete,
      });
    },
  },
  mounted() {
    this.loadData();
  },

  watch: {
    onGoingReq: function () {
      this.isListOnload = this.isEditOnload = this.onGoingReq.length > 0;
    },
  },
};
</script>
<style scoped>
.optionManager {
  row-gap: 14px;
}

.optionManagerToolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 2px 6px;
}

.optionManagerMeta {
  font-size: 13px;
  font-weight: 600;
  color: #64748b;
}

.optionManagerAddBtn {
  min-width: 108px;
  border-radius: 12px;
  box-shadow: 0 12px 26px rgba(14, 165, 233, 0.16);
}

@media (max-width: 768px) {
  .optionManagerToolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .optionManagerAddBtn {
    width: 100%;
  }
}
</style>
<style scoped>
.__container {
  clear: both;
  margin-top: 30px !important;
  border-radius: 9px;
  padding: 1%;
  margin: 1%;
  width: 98%;
  background-color: #F2F2F2;
}
</style>
